export default "__VITE_ASSET__D_5oiCxU__"